



















































import { Component } from 'vue-property-decorator';
import Mixin from '@/mixin';
import { TransitionType } from '@/config/enum';
import transitionModule from '@/store/modules/common/transition.module';
import VMenu from '@/components/menu/VMenu.vue';
import VTopNav from '@/components/menu/VTopNav.vue';
import VMessage from '@/components/items/VMessage.vue';

@Component({
  name: 'BeforeLoginLayout',
  components: { VMessage, VTopNav, VMenu }
})
export default class BeforeLoginLayout extends Mixin {
  get transitionType(): TransitionType {
    return transitionModule.transitionType;
  }
}
